import { render, staticRenderFns } from "./student-layout.vue?vue&type=template&id=2c3270d2&scoped=true&"
import script from "./student-layout.vue?vue&type=script&lang=js&"
export * from "./student-layout.vue?vue&type=script&lang=js&"
import style0 from "./student-layout.vue?vue&type=style&index=0&id=2c3270d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3270d2",
  null
  
)

export default component.exports